import { render, staticRenderFns } from "./PlayerMarketValueTrend.vue?vue&type=template&id=b0938f82&scoped=true&"
import script from "./PlayerMarketValueTrend.vue?vue&type=script&lang=js&"
export * from "./PlayerMarketValueTrend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0938f82",
  null
  
)

export default component.exports